<template>
  <div id="projects" class="content md-layout md-alignment-center-center">
    <div class="md-layout-item" style="width: 100%;">
      <h1>{{ $t("Projects") }}</h1>
      <md-list>
        <md-list-item v-for="project in projects" v-bind:key="project.name" md-expand md-expanded>
            <img :src="project.img" :alt="project.name" style="height:30px; margin-right: 32px;">
            <span class="md-list-item-text"><b>{{ $t(project.name) }}</b></span>
            <md-list slot="md-expand">
              <md-list-item class="project-content md-inset">
                <p v-html="$t(project.description)">{{ $t(project.description) }}</p>
              </md-list-item>
            </md-list>
        </md-list-item>
      </md-list>
    </div>
  </div>
</template>

<script>

import multiflow from "@/assets/scikitmultiflow.png"
import corvus from "@/assets/corvus.gif"
import mlsec from "@/assets/mlsec.png"
import brmalware from "@/assets/brmalware.png"
import ff from "@/assets/ff.png"

export default {
  name: 'Projects',
  title: 'Fabrício Ceschin - Projects',
  props: {
    // msg: String,
    // num: Number
  },
  data() {
    return {
      projects: [
        { name: "Fast & Furious: Malware Detection Data Stream Datasets", description: "ff-datasets-text", img: ff },
        { name: "Scikit-Multiflow", description: "skmultiflow-text", img: multiflow },
        { name: "Corvus_", description: "corvus-text", img: corvus },
        { name: "mlsec", description: "mlsec-text", img: mlsec },
        { name: "brmalware", description: "brmalware-text", img: brmalware }
      ]
    }
  },
  mounted() {
    this.$ga.page('/projects');
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

#projects {
  text-align:center;
}

#projects .md-list {
  background:none;
}

#projects .md-list p{
  background:none;
}

#projects .md-list-item-expand {
  border:none;
}

.project-content .md-list-item-content{
  display:block;
  padding-left:16px !important;
}

#projects .md-button-clean {
  white-space: inherit;
}

</style>
